import { Box, Chip } from '@bcp-nextgen-dx-component-factory/design-system';
import { UIHelper } from '@helpers';
import { useTranslation } from '@hooks';
import { SafeCredentialTypeEnum } from '@types';

const resources = {
	chip: {
		sms: 'screens.login.form.safe.chip.sms',
		token: 'screens.login.form.safe.chip.token',
		askSms: 'screens.login.form.safe.chip.askSms',
		useToken: 'screens.login.form.safe.chip.useToken',
	},
};

export interface ChipsListProps {
	safeCredentialType?: SafeCredentialTypeEnum | null;
	selectedChip?: SafeCredentialTypeEnum;
	onChipClick?: (chip: SafeCredentialTypeEnum) => void;
}

export const ChipsList = ({ safeCredentialType, selectedChip, onChipClick }: ChipsListProps) => {
	const { t } = useTranslation();

	if (!safeCredentialType) {
		return null;
	}

	const getChips = () => {
		switch (safeCredentialType) {
			case SafeCredentialTypeEnum.Sms:
				return (
					<Chip
						size="large"
						label={t(resources.chip.askSms)}
						selected={selectedChip === SafeCredentialTypeEnum.Sms}
						onPress={() => onChipClick?.(SafeCredentialTypeEnum.Sms)}
					/>
				);
			case SafeCredentialTypeEnum.Token:
				return (
					<Chip
						size="large"
						label={t(resources.chip.useToken)}
						selected={selectedChip === SafeCredentialTypeEnum.Token}
						onPress={() => onChipClick?.(SafeCredentialTypeEnum.Token)}
					/>
				);
			case SafeCredentialTypeEnum.SmsOrToken:
				return (
					<>
						<Chip
							size="large"
							label={t(resources.chip.sms)}
							selected={selectedChip === SafeCredentialTypeEnum.Sms}
							onPress={() => onChipClick?.(SafeCredentialTypeEnum.Sms)}
						/>
						<Chip
							size="large"
							label={t(resources.chip.token)}
							selected={selectedChip === SafeCredentialTypeEnum.Token}
							onPress={() => onChipClick?.(SafeCredentialTypeEnum.Token)}
						/>
					</>
				);
		}
	};

	return <Box styles={{ gap: UIHelper.rem(16) }}>{getChips()}</Box>;
};
